import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'components/ui/StyledSelect';
import { LanguageSelectWrapper } from './LanguageSelect.styles';

const languageOptions = [
  { languageName: `translations.english`, languageValue: `uk-en` },
  { languageName: `translations.french`, languageValue: `fr-fr` },
  { languageName: `translations.dutch`, languageValue: `nl-nl` },
  { languageName: `translations.german`, languageValue: `de-de` }
];

const LanguageSelect = ({ onSelect, value, className, defaultValue, intl }) => (
  <>
    <LanguageSelectWrapper>{intl.formatMessage({ id: 'vouchers.language' }).toUpperCase()}</LanguageSelectWrapper>
    <StyledSelect
      data-testid="select"
      className={className}
      id="language-select"
      data-cy="language-select"
      onChange={(e) => onSelect(e.target.value)}
      defaultValue={defaultValue}
      value={value}
    >
      {languageOptions.map(({ languageName, languageValue }, index) => (
        <option key={`${languageName}--${index}`} value={languageValue}>
          {intl.formatMessage({ id: `${languageName}` })}
        </option>
      ))}
    </StyledSelect>
  </>
);

LanguageSelect.propTypes = {
  onSelect: PropTypes.func,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func
  })
};

export default LanguageSelect;
